/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valid_Email_Required_ErrorInputs */

const en_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter a valid email address.`)
};

const id_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan masukkan alamat email yang valid.`)
};

const ms_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila masukkan alamat emel yang sah.`)
};

const ca_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si us plau, introdueix una adreça de correu electrònic vàlida.`)
};

const cs_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte platnou emailovou adresu.`)
};

const da_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast en gyldig e-mailadresse.`)
};

const de_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie eine gültige E-Mail-Adresse ein.`)
};

const et_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palun sisestage kehtiv e-posti aadress.`)
};

const es_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce una dirección de correo electrónico válida.`)
};

const fr_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez saisir une adresse e-mail valide.`)
};

const hr_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molimo unesite važeću e-mail adresu.`)
};

const it_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un indirizzo email valido.`)
};

const lv_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lūdzu, ievadiet derīgu e-pasta adresi.`)
};

const lt_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Įveskite galiojantį el. pašto adresą.`)
};

const hu_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, adjon meg egy érvényes e-mail címet.`)
};

const nl_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord vereist.`)
};

const nb_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skriv inn en gyldig e-postadresse.`)
};

const pl_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podaj prawidłowy adres e-mail.`)
};

const pt_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, insira um endereço de e-mail válido.`)
};

const ro_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vă rugăm să introduceți o adresă de e-mail validă.`)
};

const sk_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadajte platnú e-mailovú adresu.`)
};

const sl_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prosimo, vnesite veljaven e-poštni naslov.`)
};

const fi_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä kelvollinen sähköpostiosoite.`)
};

const sv_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänligen ange en giltig e-postadress.`)
};

const vi_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập một địa chỉ email hợp lệ.`)
};

const tr_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lütfen geçerli bir e-posta adresi girin.`)
};

const el_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παρακαλούμε εισάγετε μια έγκυρη διεύθυνση email.`)
};

const bg_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, въведете валиден имейл адрес.`)
};

const ru_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите действительный адрес электронной почты.`)
};

const sr_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Молимо унесите важећу имејл адресу.`)
};

const uk_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь ласка, введіть дійсну адресу електронної пошти.`)
};

const ka_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გთხოვთ შეიყვანოთ ვალიდური მეილის მისამართი.`)
};

const hi_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया एक वैध ईमेल पता दर्ज करें।`)
};

const th_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดป้อนที่อยู่อีเมลที่ถูกต้อง`)
};

const ko_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유효한 이메일 주소를 입력해 주세요.`)
};

const zh_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入有效的电子邮件地址。`)
};

const zh_tw_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請輸入有效的電子郵件地址。`)
};

const ja_valid_email_required_error = /** @type {(inputs: Valid_Email_Required_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効なメールアドレスを入力してください。`)
};

/**
* | output |
* | --- |
* | "Please enter a valid email address." |
*
* @param {Valid_Email_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const valid_email_required_error = /** @type {((inputs?: Valid_Email_Required_ErrorInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valid_Email_Required_ErrorInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_valid_email_required_error(inputs)
	if (locale === "ms") return ms_valid_email_required_error(inputs)
	if (locale === "ca") return ca_valid_email_required_error(inputs)
	if (locale === "cs") return cs_valid_email_required_error(inputs)
	if (locale === "da") return da_valid_email_required_error(inputs)
	if (locale === "de") return de_valid_email_required_error(inputs)
	if (locale === "et") return et_valid_email_required_error(inputs)
	if (locale === "es") return es_valid_email_required_error(inputs)
	if (locale === "fr") return fr_valid_email_required_error(inputs)
	if (locale === "hr") return hr_valid_email_required_error(inputs)
	if (locale === "it") return it_valid_email_required_error(inputs)
	if (locale === "lv") return lv_valid_email_required_error(inputs)
	if (locale === "lt") return lt_valid_email_required_error(inputs)
	if (locale === "hu") return hu_valid_email_required_error(inputs)
	if (locale === "nl") return nl_valid_email_required_error(inputs)
	if (locale === "nb") return nb_valid_email_required_error(inputs)
	if (locale === "pl") return pl_valid_email_required_error(inputs)
	if (locale === "pt") return pt_valid_email_required_error(inputs)
	if (locale === "ro") return ro_valid_email_required_error(inputs)
	if (locale === "sk") return sk_valid_email_required_error(inputs)
	if (locale === "sl") return sl_valid_email_required_error(inputs)
	if (locale === "fi") return fi_valid_email_required_error(inputs)
	if (locale === "sv") return sv_valid_email_required_error(inputs)
	if (locale === "vi") return vi_valid_email_required_error(inputs)
	if (locale === "tr") return tr_valid_email_required_error(inputs)
	if (locale === "el") return el_valid_email_required_error(inputs)
	if (locale === "bg") return bg_valid_email_required_error(inputs)
	if (locale === "ru") return ru_valid_email_required_error(inputs)
	if (locale === "sr") return sr_valid_email_required_error(inputs)
	if (locale === "uk") return uk_valid_email_required_error(inputs)
	if (locale === "ka") return ka_valid_email_required_error(inputs)
	if (locale === "hi") return hi_valid_email_required_error(inputs)
	if (locale === "th") return th_valid_email_required_error(inputs)
	if (locale === "ko") return ko_valid_email_required_error(inputs)
	if (locale === "zh") return zh_valid_email_required_error(inputs)
	if (locale === "zh-tw") return zh_tw_valid_email_required_error(inputs)
	if (locale === "ja") return ja_valid_email_required_error(inputs)
	return en_valid_email_required_error(inputs)
});